/* ==========================================================================
   Makes the server-rendered star rating scroll to the reviews on the page.

   The rating links to #shopify-product-reviews, which is the theme's own
   convention and the anchor the legacy Shopify Product Reviews app provided.
   This store's reviews come from an app that renders its own widget instead
   and provides no such anchor, so theme.js strips the href and the stars stop
   being clickable.

   This finds whichever review widget actually rendered and scrolls to it.
   Deliberately no network, no polling loop beyond the app's own paint, and no
   work at all on a page without a rating: the whole point of rendering the
   stars server-side was to stop the review app being on the critical path.
   ========================================================================== */
(function () {
  'use strict';

  // The snippet ships one script tag per product section; the listener below
  // is delegated, so one execution serves every rating on the page.
  if (window.productRatingJumpInitialized) return;
  window.productRatingJumpInitialized = true;

  var WIDGETS = [
    '#shopify-product-reviews',
    '.yotpo-widget-instance[class*="reviews"]',
    '.yotpo-reviews-main-widget',
    '#yotpo-reviews-main-widget',
    '.yotpo.yotpo-main-widget',
    '.spr-reviews',
    '[data-reviews-section]'
  ];

  function reviewsTarget() {
    for (var i = 0; i < WIDGETS.length; i++) {
      var el = document.querySelector(WIDGETS[i]);
      // A widget that has not painted yet occupies no space, and scrolling to
      // it would land the shopper on whatever happens to be there instead.
      if (el && el.getBoundingClientRect().height > 0) return el;
    }
    return null;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-review-jump]');
    if (!link) return;

    var target = reviewsTarget();
    if (!target) return; // Let the href do whatever it can.

    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // theme.js removes the href when #shopify-product-reviews is absent, which
  // also removes the focus order and the pointer cursor. Once some widget has
  // painted, put the affordance back without reinstating a dead fragment.
  function markAvailable() {
    if (!document.querySelector('[data-review-jump]')) return true;
    if (!reviewsTarget()) return false;

    Array.prototype.forEach.call(document.querySelectorAll('[data-review-jump]'), function (link) {
      // Something to scroll to exists, so the cursor is allowed to promise a
      // jump. Before this point a click would land nowhere.
      link.setAttribute('data-review-jump-ready', '');

      // theme.js left the href alone, so #shopify-product-reviews really is on
      // the page: a native anchor is already focusable, already has the
      // pointer, and is still worth middle-clicking. Downgrading it to
      // role="button" would take all three away to fix nothing.
      if (link.getAttribute('href')) return;

      // The stars are the same jump again for the mouse, and they already
      // carry role="img" with the rating as their accessible name. Turning
      // them into a button would take the rating away from screen readers and
      // add a tab stop that goes exactly where the count link beside them
      // already goes.
      if (link.hasAttribute('role')) return;

      link.setAttribute('role', 'button');
      link.setAttribute('tabindex', '0');
    });

    return true;
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var link = event.target.closest && event.target.closest('[data-review-jump][role="button"]');
    if (!link) return;
    event.preventDefault();
    link.click();
  });

  // The widget paints on its own schedule; stop looking once it has, and give
  // up after 20s rather than leaving a timer running for the session.
  if (!markAvailable()) {
    var tries = 0;
    var poll = setInterval(function () {
      if (markAvailable() || ++tries >= 40) clearInterval(poll);
    }, 500);
  }
})();
